module.exports = "var aNumber = 42"